function CardYellow(){
  return(<div>CardBlue</div>)
}

export default CardYellow